/**
 * isOwnerPremium — fuente de verdad única para detectar las cuentas
 * Admin/Premium permanentes de DamyxIA en el frontend.
 *
 * IMPORTANTE: Esta lista debe coincidir EXACTAMENTE con:
 *   - /app/backend/.env → PREMIUM_OVERRIDE_EMAILS / AUTHORIZED_CREATOR_EMAILS
 *   - /app/backend/services/owner_seed.py
 *   - /app/memory/test_credentials.md
 *
 * Si Marcelo agrega/quita una cuenta del seed backend, actualizar también esta lista.
 * Mientras tanto, estas 7 cuentas tienen acceso PERMANENTE a todas las features
 * Premium en el frontend, incluso si el localStorage.isPremium quedó stale por
 * race condition al login (antes que /auth/me termine).
 *
 * Decisión Marcelo (feb-2026): "quiero que todos mis correos que son Admin y
 * Premium tengan acceso a todo lo de premium permanente hasta una orden mía
 * diciendo lo contrario".
 */

const OWNER_PREMIUM_EMAILS = new Set([
  // Dueños (admin + premium lifetime)
  'damyxia@gmail.com',
  'marcmarl2@gmail.com',
  'manager@damyxia.com',
  'support@damyxia.com',
  // Premium autorizados (lifetime)
  'martila4166@gmail.com',
  'damy2307@gmail.com',
  'silviacaridad12345@gmail.com',
  'marmarcmarl@gmail.com',
]);

/**
 * Lee el email actual del localStorage y verifica si está en la whitelist.
 * No depende de localStorage.isPremium (que puede quedar stale).
 */
export function isOwnerPremiumEmail(email) {
  if (!email) return false;
  return OWNER_PREMIUM_EMAILS.has(String(email).trim().toLowerCase());
}

/**
 * Util para el caso típico: detectar si el usuario actual (según localStorage)
 * es owner-premium permanente.
 */
export function isCurrentUserOwnerPremium() {
  try {
    const e = localStorage.getItem('userEmail');
    return isOwnerPremiumEmail(e);
  } catch {
    return false;
  }
}

export default OWNER_PREMIUM_EMAILS;
